<template>
  <div>
    <el-card>
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20" class="searchRow">
          <el-col :sm="24" :md="12" :lg="4">
            <el-cascader style="width: 100%" clearable v-model="campusIdList" :show-all-levels="false"
                         :props="campusTreeProps" placeholder="请选择学员所属校区" :options="campusList" collapse-tags
                         @change="campusIdListChange"></el-cascader>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-cascader style="width: 100%" clearable collapse-tags v-model="courseIds"
                         :show-all-levels="false"
                         :props="subjectTreeProp" placeholder="请输入所属科目" :options="subjectTreeList"
                         @change="subjectChangeTop"></el-cascader>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <el-input v-model="searchForm.goodsName" placeholder="请输入商品名" auto-complete="off"></el-input>
          </el-col>
          <el-col :sm="24" :md="24" :lg="8">
            <el-date-picker style="width: 100%" v-model="createTime" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="下单开始日期"
                            end-placeholder="下单结束日期" :picker-options="pickerOptions"
                            @change="createTimeChange"></el-date-picker>
          </el-col>
          <el-col :sm="8" :md="8" :lg="4" style="text-align: right; float: right">
            <el-button type="primary" style @click="getOrderReport" icon="el-icon-search">
              查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <div style="margin-top: 20px">
      <el-row :gutter="20">
        <el-col :sm="24" :md="12" :lg="8">
          <el-card class="box-card" shadow="hover" header="总销量（个）">
            <div class="card-number">{{number}}</div>
          </el-card>
        </el-col>
        <el-col :sm="24" :md="12" :lg="8">
          <el-card class="box-card" shadow="hover" header="总销售额(元）">
            <div class="card-number">{{sum}}</div>
          </el-card>
        </el-col>
        <el-col :sm="24" :md="12" :lg="8">
          <el-card class="box-card" shadow="hover" header="平均单价（元）">
            <div class="card-number">{{averagePrice}}</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div style="margin-top: 20px">
      <el-row :gutter="20">
        <el-col :sm="24" :md="24" :lg="18">
          <el-card shadow="hover">
            <div id="lineChart" style="width: 100%;height:400px;"></div>
          </el-card>
        </el-col>

        <el-col :sm="24" :md="24" :lg="6">
          <el-card shadow="hover">
            <div id="pieChart" style="width:100%;height:400px;"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/line");
require("echarts/lib/chart/pie");
export default {
  name: "orderReport",
  data() {
    return {
      searchForm: {
        campusIdList: [],
        subjectIds: [],
        goodsName: '',
        createTimeBegin: '',
        createTimeEnd: ''
      },
      formLabelWidth: "80px",
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      campusList: [],
      campusIdList: [],
      courseIds: [],
      createTime: [],
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        multiple: true,
      },
      subjectTreeList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      hasPermission: false,
      lineChart: {},
      pieChart: {},
      number: '-',
      sum: '-',
      averagePrice: '-',
      orderReportRankList: [],
      pieList: [],
    }
  },
  methods: {
    initLineChart() {
      this.lineChart = echarts.init(document.getElementById("lineChart"));
      let seriesData = []
      this.orderReportRankList.forEach(e => {
        seriesData.push(e.totalPrice)
      })
      this.option = {
        title: {text: "商品销售排名"},
        tooltip: {
          trigger: "axis",
          textStyle: {align: "left"},
        },
        toolBox: {
          show: true,
          feature: {
            dataView: {show: true},
            dataZoom: {show: true},
            magicType: {type: ['line', 'bar']},
            restore: {show: true},
            saveAsImage: {show: true}
          },
        },
        xAxis: {
          data: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
          splitLine: {show: false},
          splitArea: {show: false},
          axisLine: {
            lineStyle: {
              type: "solid",
              //color: '#d8d8d8',
              width: "1",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          name: "",
          //max:
          min: 0,
          type: "value",
          axisLine: {
            show: false,
          },
        },
        legend: {
          //itemWidth: 34,
          //itemHeight: 14,
          // align: "left",
          // data: ["电压", "电流", "有功功率", "频率", "功率因数", "用电量"],
        },
        series: {
          data: seriesData,
          type: 'line'
        },
      }
      window.addEventListener("resize", this.lineChart.resize());
      this.lineChart.setOption(this.option);
    },
    initPieChart() {
      this.pieChart = echarts.init(document.getElementById("pieChart"));
      let seriesData = [];
      this.pieList.forEach(e => {
        seriesData.push({
          name: e.paidState === 1 ? '已付款' : '代付款',
          value: e.number,
        })
      });
      var option = {
        title: {
          text: '订单状态占比分布',
          x: 'left',              //标题位置
          // textStyle: { //标题内容的样式
          //   color: '#000',
          //   fontStyle: 'normal',
          //   fontWeight: 100,
          //   fontSize: 16 //主题文字字体大小，默认为18px
          // },
        },
        // stillShowZeroSum: true,
        //鼠标划过时饼状图上显示的数据
        tooltip: {
          trigger: 'item',
          formatter: '{a}<br/>{b}:{c} ({d}%)'
        },
        //图例
        legend: {//图例  标注各种颜色代表的模块
          // orient: 'vertical',//图例的显示方式  默认横向显示
          bottom: 10,//控制图例出现的距离  默认左上角
          left: 'center',//控制图例的位置
          // itemWidth: 16,//图例颜色块的宽度和高度
          // itemHeight: 12,
          textStyle: {//图例中文字的样式
            color: '#000',
            fontSize: 16
          },
          data: ['已付款', '代付款']//图例上显示的饼图各模块上的名字
        },
        //饼图中各模块的颜色
        color: ['#32dadd', '#b6a2de'],
        // 饼图数据
        series: {
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          // data:''
          data: seriesData,
          itemStyle: {
            normal: {
              label: {
                show: true,//饼图上是否出现标注文字 标注各模块代表什么  默认是true
                // position: 'inner',//控制饼图上标注文字相对于饼图的位置  默认位置在饼图外
              },
              labelLine: {
                show: true//官网demo里外部标注上的小细线的显示隐藏    默认显示
              }
            }
          },
        }

      }
      this.pieChart.setOption(option)
    },
    getCampusList() {
      this.api.campus.getPermissionCampusTree({
        parentId: 1
      }).then((result) => {
        for (let item of result.data) {
          if (item.children.length !== 0) {
            for (let items of item.children) {
              if (items.children.length !== 0) {
                for (let itemss of items.children) {
                  if (itemss.children.length !== 0) {
                    delete itemss.children;
                  } else {
                    delete itemss.children;
                  }
                }
              } else {
                delete items.children;
              }
            }
          } else {
            delete item.children;
          }
        }
        this.campusList = result.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    campusIdListChange() {
      this.searchForm.campusIdList = [];
      this.campusIdList.forEach((e) => this.searchForm.campusIdList.push(e[2]));
    },
    getSubjectTreeList() {
      this.api.campus.getPermissionSubjectTree().then((result) => {
        for (let item of result.data) {
          if (item.children.length !== 0) {
            for (let items of item.children) {
              delete items.children;
            }
          }
        }
        this.subjectTreeList = result.data;
      }).catch((error) => {
        console.log(error);
      });
    },
    subjectChangeTop() {
      if (this.courseIds) {
        this.searchForm.subjectIds = [];
        this.courseIds.forEach((item) => {
          this.searchForm.subjectIds.push(item[1]);
        });
      } else {
        this.searchForm.subjectIds = [];
      }
    },
    createTimeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    getOrderReport() {
      console.log(this.searchForm)
      this.api.orderInfo.getOrderReport(
        this.searchForm
      ).then(res => {
        if(res.success) {
          this.number = res.data.number
          this.sum = res.data.sum
          this.averagePrice = res.data.averagePrice
          this.orderReportRankList = res.data.orderReportRankList
          this.pieList = res.data.pieList
          this.initLineChart()
          this.initPieChart()
          if(this.number === 0) {
            this.$message.error('暂无无数据')
          }
        } else {
          this.$message.error('获取数据失败')
        }
      })
    }
  },
  mounted() {
    this.getOrderReport()
    this.getCampusList()
    this.getSubjectTreeList()
  }
}
</script>

<style scoped>
.card-number {
  font-weight: 600;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInfo/orderReport.vue